import computeEmployeeLevel from './compute-employee-level';

const formatUserName = (assignee) => {
  if (!assignee) {
    return '';
  }

  const name = typeof assignee.name === 'string' ? assignee.name.trim() : '';
  if (name) {
    return name;
  }

  if (assignee.username) {
    return assignee.username;
  }

  if (assignee.email) {
    return assignee.email;
  }

  return assignee.userId ? String(assignee.userId) : '';
};

/**
 * Агрегирует баллы по исполнителям задач и определяет уровень каждого.
 * Если у задачи несколько исполнителей — каждый получает полные баллы задачи.
 */
export default function computeEmployeeLevelsByAssignees(
  tasks,
  employeePlans,
  savedLevels = [],
  shiftsPerPlan = 15,
) {
  const savedByUserId = new Map(
    (savedLevels || []).map((entry) => [String(entry.userId), entry]),
  );
  const byUserId = new Map();

  (tasks || []).forEach((task) => {
    const totalPoints = Number(task.totalPoints) || 0;
    const assignees = Array.isArray(task.assignees) ? task.assignees : [];

    assignees.forEach((assignee) => {
      const userId = assignee?.userId;
      if (userId === null || userId === undefined || userId === '') {
        return;
      }

      const key = String(userId);
      const existing = byUserId.get(key) || {
        userId: key,
        name: formatUserName(assignee),
        organization:
          (typeof assignee.organization === 'string' && assignee.organization.trim()) ||
          savedByUserId.get(key)?.organization ||
          '',
        totalPoints: 0,
        workCount: 0,
        workedDays: savedByUserId.get(key)?.workedDays ?? null,
        level: null,
      };

      existing.totalPoints += totalPoints;
      existing.workCount += 1;

      if (!existing.name) {
        existing.name = formatUserName(assignee);
      }

      if (!existing.organization && typeof assignee.organization === 'string') {
        existing.organization = assignee.organization.trim();
      }

      byUserId.set(key, existing);
    });
  });

  return Array.from(byUserId.values())
    .map((entry) => ({
      ...entry,
      level: computeEmployeeLevel(
        employeePlans,
        entry.totalPoints,
        entry.workedDays,
        shiftsPerPlan,
      ),
    }))
    .sort((a, b) => a.name.localeCompare(b.name, 'ru'));
}
